import { useState, useEffect, useCallback } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

function useGetLocations() {
  const [drivers, setDrivers] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [pinData, setPinData] = useState([]);
  const [selectedPin, setSelectedPin] = useState(null);

  const [polyLine, setPolyLine] = useState([]);
  const [selectedArea, setSelectedArea] = useState('');

  const [allDestinations, setAllDestinations] = useState([]);
  const [hoverDestination, setHoverDestination] = useState(null);
  const [selectedData, setSelectedData] = useState('Show All Data');

  useEffect(() => {
    fetchDrivers();
    fetchSiteAssesmentId();
    fetchAllDestinations();
  }, []);

  const fetchSiteAssesmentId = async () => {
    try {
      const response = await customAxios.get('Ops/GetContracts?flagActive=1', { headers: authHeader() });

      if (response.status === 200) {
        const ids = response.data.map(item => item.siteAssessmentID).filter(id => id && id !== 0);

        fetchAllPins(ids);
        fetchAllPolylines(ids);
      }
    } catch (err) {
      console.error('Error fetching site IDs:', err);
    }
  };

  const fetchDrivers = useCallback(async (isRefresh = false) => {
    try {
      if (isRefresh) {
        setRefreshing(true);
      }
      const response = await customAxios.get('/Ops/GetUserLocation', {
        headers: authHeader(),
      });

      if (response.status === 200) {
        setDrivers(Array.isArray(response.data) ? response.data : [response.data]);
      } else {
        setDrivers([]);
      }
    } catch (err) {
      console.error('API call failed:', err);
      setDrivers([]);
    } finally {
      if (isRefresh) {
        setRefreshing(false);
      }
    }
  }, []);

  async function fetchAllPins(ids) {
    try {
      const allPins = [];

      for (const id of ids) {
        const response = await customAxios.get(`/SiteDetails/GetSiteDetailsMapCoordinates/${id}?mapType=pin`, {
          headers: authHeader(),
        });

        if (response.status === 200) {
          const pins = Array.isArray(response.data) ? response.data : [response.data];
          allPins.push(...pins.map(p => ({ ...p, siteAssessmentID: id })));
        }
      }

      setPinData(allPins);
      console.log('All pins updated');
    } catch (err) {
      console.error('Error fetching all pins:', err);
    }
  }

  async function fetchAllPolylines(ids) {
    try {
      const allPolygons = [];

      for (const id of ids) {
        const response = await customAxios.get(`/SiteDetails/GetSiteDetailsMapCoordinates/${id}?mapType=polygon`, {
          headers: authHeader(),
        });

        if (response.status === 200 && response.data) {
          allPolygons.push({ siteAssessmentID: id, data: response.data });
        }
      }

      setPolyLine(allPolygons);
      console.log('All polygons updated');
    } catch (err) {
      console.error('Error fetching all polygons:', err);
    }
  }

  // 🔹 destinations logic
  async function fetchAllDestinations() {
    try {
      const response = await customAxios.get('/CRM/GetAllCustomerLocations', { headers: authHeader() });

      if (response.status === 200) {
        setAllDestinations(response.data);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }

  // function handleSiteChange(e) {
  //   setSelectedSite(e.target.value); // ❌ not used
  // }

  return {
    drivers,
    refreshing,
    selectedDriver,
    setSelectedDriver,
    // selectedSite, setSelectedSite, handleSiteChange, // ❌ not used
    pinData,
    selectedPin,
    setSelectedPin,
    polyLine,
    selectedArea,
    setSelectedArea,
    // siteId, setPinData, setPolyLine, // ❌ not used
    allDestinations,
    hoverDestination,
    setHoverDestination,
    selectedData,
    setSelectedData,
    fetchAgain: () => fetchDrivers(true),
  };
}

export default useGetLocations;
